import { render } from "./ConfigurationSysteme.vue?vue&type=template&id=28c02ddc&scoped=true"
import script from "./ConfigurationSysteme.vue?vue&type=script&lang=js"
export * from "./ConfigurationSysteme.vue?vue&type=script&lang=js"

import "./ConfigurationSysteme.vue?vue&type=style&index=0&id=28c02ddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c02ddc"]])

export default __exports__